import {
  Routes,
  Route,
  useNavigate,
  useLocation
} from "react-router-dom";
import HomePage from "./pages/homePage/HomePage";
import Cart from "./components/cart/Cart";
import Checkout from "./components/checkout/Checkout";
import { useEffect, useState } from "react";
import Navbar from "./components/nabvar/Navbar";
import LocationModal from "./components/micro-componets/LocationModal";


function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeCode, setActiveCode] = useState(null);
  const [showLocationModal, setShowLocationModal] = useState(false);

  useEffect(() => {
    const pathParts = location.pathname.split("/");
    const segment = pathParts[1]; // first segment after "/"

    // Only treat as campaignCode if it's not a static route
    const staticRoutes = ["", "cart", "checkout"];
    if (segment && !staticRoutes.includes(segment)) {
      localStorage.setItem("campaignCode", segment);
      setActiveCode(segment);
      setShowLocationModal(false);
    } else {
      // No campaign code in URL → check localStorage
      const storedCode = localStorage.getItem("campaignCode");
      if (storedCode) {
        setActiveCode(storedCode);
        setShowLocationModal(false);
      } else {
        // Nothing anywhere → force location modal
        setActiveCode(null);
        setShowLocationModal(true);
      }
    }
  }, [location]);

  const handleResolved = (code) => {
    localStorage.setItem("campaignCode", code);
    setActiveCode(code);
    setShowLocationModal(false);
    navigate(`/${code}`);
  };

  return (
    <>
      <Navbar
        campaignCode={activeCode}
        onChangeBranch={() => setShowLocationModal(true)}
      />
      <Routes>
        <Route path="/:campaignCode" element={<HomePage activeCode={activeCode} />} />
        <Route path="/" element={<HomePage activeCode={activeCode} />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
      </Routes>
      <LocationModal
        open={showLocationModal}
        onResolved={handleResolved}
        onClose={() => setShowLocationModal(false)}
      />
    </>
  );
}


export default App;
